export default __webpack_public_path__ + "static/media/tiny1.912db268.jpg";